import "./Loading.scss";

const Loading = () => {
  return (
    <div className="loading">
      <div className="beerflight-div">
        {/* <img className="beerflight" src="/flight.svg" alt="The beerflight" /> */}
        <div className="circles-container">
          {[...Array(5)].map((_, i) => (
            <div
              className="circle"
              style={{ "--i": i } as React.CSSProperties}
              key={i}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Loading;
